import { mapAdvertisingPlatformFromDTO } from '@entities/advertising-platform/api/mappers'
import type {
    Partner,
    PartnerDTO,
    PartnerOrd,
    PartnerOrdDTO,
    PartnerStatistics,
    PartnerStatisticsDTO
} from '../model/types'
import type { CreatePartnerArgs, CreatePartnerArgsDTO } from './types'

export const mapPartnerFromDTO = ({
    id,
    name,
    tg_username,
    email,
    phone,
    comment,
    created_at,
    statistics,
    advertising_platforms,
    rating,
    linked_partner_id,
    photo_url,
    linked_partner
}: PartnerDTO): Partner => ({
    id,
    name,
    tgUsername: tg_username,
    email,
    phone,
    comment,
    createdAt: new Date(created_at),
    statistics: statistics && mapPartnerStatisticsFromDTO(statistics),
    advertisingPlatforms: advertising_platforms?.map(mapAdvertisingPlatformFromDTO),
    rating,
    linkedPartnerId: linked_partner_id,
    photoUrl: photo_url,
    linkedPartner: linked_partner ? mapPartnerFromDTO(linked_partner) : null
})

export const mapPartnerToDTO = ({
    name,
    tgUsername,
    email,
    phone,
    comment,
    rating,
    linkedPartnerId,
    relatedChannel
}: CreatePartnerArgs): CreatePartnerArgsDTO => ({
    name,
    tg_username: tgUsername,
    email,
    phone,
    comment,
    rating,
    linked_partner_id: linkedPartnerId,
    related_channel: relatedChannel
})

export const mapPartnerORDFromDTO = ({
    organization,
    type,
    name,
    mobile_phone,
    kpp,
    inn,
    fio,
    ogrn,
    address,
    is_ors,
    is_rr,
    rs_url
}: PartnerOrdDTO): PartnerOrd => ({
    organization,
    type,
    name,
    mobilePhone: mobile_phone,
    kpp,
    inn,
    fio,
    ogrn,
    address,
    isORS: is_ors,
    isRR: is_rr,
    rsUrl: rs_url
})

export const mapPartnerORDToDTO = ({
    organization,
    type,
    name,
    mobilePhone,
    kpp,
    inn,
    fio,
    ogrn,
    address,
    isORS,
    isRR,
    rsUrl
}: PartnerOrd): PartnerOrdDTO => ({
    organization,
    type,
    name,
    mobile_phone: mobilePhone,
    kpp,
    inn,
    fio,
    ogrn,
    address,
    is_ors: isORS,
    is_rr: isRR,
    rs_url: rsUrl
})

const mapPartnerStatisticsFromDTO = ({
    purchased_count,
    purchased_amount,
    sold_count,
    sold_amount
}: PartnerStatisticsDTO): PartnerStatistics => ({
    purchasedCount: purchased_count,
    purchasedAmount: purchased_amount,
    soldCount: sold_count,
    soldAmount: sold_amount
})
